module.exports = __webpack_public_path__ + "static/media/icons8-azure.2ee54437.svg";